<template lang="pug">
  footer.footer(itemscope itemtype="https://schema.org/WPFooter")
    div.footer-container
      div.footer-text
        span Design &amp;&nbsp;
          strike in
          |  Development by Jorge Moliner.
        span © Copyrights 2018. All Rights Reserved.

        //- br
        //- button.modal_toggle(type="button") - Site Credits -

    //-
      Back to Top Button
    BackTop
</template>


<script>
  export default {
    data () {
      return {
        wiki: 'https://es.wikipedia.org/wiki/Valencia'
      }
    }
  }
</script>


<style lang="sass" scoped>
  .footer
    position: relative
    z-index: 1
    display: flex
    justify-content: center
    text-align: center
    &-container
      margin: 0 auto
      padding: 0 2.5rem
      position: relative
      width: 100%
    &-text
      color: $VeryLightGray
      font-size: .70rem
      line-height: 1.8
      margin: 2rem 0
      a:hover
        border-bottom: 1px solid #fff

      // Responsive
      +breakpoint(lg)
        font-size: .850rem
      > span
        display: block
      > button
        transition: color .4s
        line-height: 1.6
        &:hover
          color: $orange
</style>



// WEBPACK FOOTER //
// src/components/core/Footer.vue